var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-img',{staticClass:"inline-svg-img",style:(_vm.cssVars),attrs:{"height":_vm.height,"width":_vm.width,"contain":_vm.contain,"cover":_vm.cover}},[_c('div',{staticClass:"inline-svg-img__content",domProps:{"innerHTML":_vm._s(_vm.svgContent)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }